import clsx from 'clsx'
import { memo } from 'react'
import { appDay } from 'shared/day'
import { useAppSelector } from 'shared/hooks'

import user from '../../../../assets/image/icons/svg/user.svg'
import { selectors } from '../../utils/selectors'
import { formatTime } from '../../utils/utils'
import { Reactions } from '../Emoji/Reactions'
import { messageActions } from '../MessageActions'
import { useOpened } from '../MessageActions/useOpened'
// import anchor from '../MessageActions/MessageActions.module.scss'
import { MessageBody } from './Body'
import css from './Message.module.scss'

function Message_({
	id,
	showAvatar = false
}: { id: string } & { showAvatar?: boolean }) {
	const message = useAppSelector(state =>
		selectors.messages.selectById(state, id)
	)

	const { isOpen, openClass, triggerRef } = useOpened(id)

	if (!message) {
		return null
	}

	const created = appDay(message.created_at)

	const isSystemMessage = message.render_format === 'SYSTEM'
	const isDeleted = message.render_format === 'RECALLED'

	const showActions = isDeleted ? undefined : messageActions.open

	const closeActions = isDeleted ? undefined : messageActions.onTriggerClose

	// const closeActions = (event: SyntheticEvent<HTMLElement>) => {
	// 	setContextMessage(null)
	// 	messageActions.onTriggerClose()
	// }

	return (
		<section className={css[isSystemMessage ? 'system' : 'root']}>
			{!isSystemMessage && showAvatar && (
				<img
					alt='avatar'
					className={css.avatar}
					src={message.from?.pictureUrl || user}
				/>
			)}
			<div className={css.textBlock}>
				{showAvatar && (
					<p className={css.sender}>
						<a
							className={css.name}
							href={`https://www.linkedin.com/in/${message.from?.entityId}/`}
							rel='noreferrer'
							target='_blank'
						>
							{message.from?.fullName}
						</a>

						<time
							className={css.time}
							dateTime={message.created_at}
							title={created.format('dddd, MMMM D, YYYY')}
						>
							{formatTime(message.created_at)}
						</time>
					</p>
				)}
				<div
					className={clsx(css.message, openClass, isOpen && css.messageActive)}
					data-id={id}
					onBlur={closeActions}
					onFocus={showActions}
					onMouseEnter={showActions}
					onMouseLeave={closeActions}
					ref={triggerRef}
					tabIndex={isDeleted ? -1 : 0}
				>
					<MessageBody {...message} />
				</div>
				{!isDeleted && <Reactions {...message} />}
			</div>
		</section>
	)
}

export const Message = memo(Message_)
